import { render, staticRenderFns } from "./TypeCertificationVG.vue?vue&type=template&id=58fed7be"
import script from "./TypeCertificationVG.vue?vue&type=script&lang=js"
export * from "./TypeCertificationVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports